module.exports = __webpack_public_path__ + "static/media/snowfall_3.b868cabd.png";